import styled from '@emotion/styled';

export const Container = styled.div`
  --dark-blue: #1f2d49;

  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #efefef;
  top: var(--header-height);
  display: flex;
  flex-direction: column;
  align-items: center;

  * {
    letter-spacing: 0.0864rem;
  }

  .title {
    color: var(--dark-blue);
    font-size: 0.9rem;
    height: fit-content;
    line-height: normal;
    font-weight: 500;
    margin: 1.25rem 0 0.5rem;
  }

  .bar {
    width: 31vw;
    height: 0.25rem;
    margin-bottom: 12.75rem;
    background-color: var(--dark-blue);

    @media (orientation: landscape) {
      margin-bottom: 0.5rem;
    }
  }

  .qrCode {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.9rem;

    img {
      width: 12.5rem;
      aspect-ratio: 1;
      object-fit: contain;
    }

    p {
      color: #8b8b8b;
      font-size: 0.9rem;
    }
  }
`;
